import React, { useContext, useEffect, useRef, useState } from "react";
import { HambergerMenu } from "iconsax-react";
import { useNavigate } from "react-router-dom";
import { Avatar, LogOut, MyProfile, Notifications } from "../assets/svg";
import layoutContext from "./layoutContext";
import { useDispatch, useSelector } from "react-redux";
import { adminGetProfileData } from "../redux/auth/slice";
import ConfirmationModel from "../components/common/ConfirmationModel";
import NotificationModal from "../pages/notification/NotificationModal";
import { getNotification } from "../redux/notification/slice";

const Header = () => {
  const { isAsideOpen, setIsAsideOpen } = useContext(layoutContext);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useDispatch();
  const profileRef = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    dispatch(adminGetProfileData());
    dispatch(
      getNotification({
        search: "",
        pageCount: 1,
        pageLimit: 10,
        sort_by: "",
        date_range: "",
      })
    );
  }, []);

  const { getProfileData, getNotificationData } = useSelector((store) => ({
    getProfileData: store?.authData?.adminGetProfileDataStatus?.data,
    getNotificationData:
      store?.notificationData?.getNotificationStatus?.data?.data,
  }));

  // Function to handle clicks outside the profile dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const logOutClear = () => {
    sessionStorage.clear();
    navigate("/login");
  };

  return (
    <>
      <header className="sticky top-0 left-0 w-full z-[9]">
        <div className="shadow-md bg-headerDark h-16 w-full flex justify-between items-center px-4">
          <div className="flex gap-2 cursor-pointer">
            <span onClick={() => setIsAsideOpen(!isAsideOpen)}>
              <div className="text-white flex items-center">
                <HambergerMenu size="22" className="mr-3" />
                <p className="text-base font-Proxima">FBK ERP System</p>
              </div>
            </span>
          </div>
          <div className="flex items-center space-x-5">
            <div
              className="relative cursor-pointer"
              onClick={() => setOpen(true)}
            >
              <Notifications />
              {getNotificationData?.data?.filter((note) => note?.is_read === 0)
                ?.length > 0 && (
                <span className="absolute top-0 -right-1 translate-x-1 w-2 h-2 bg-notification rounded-full"></span>
              )}
            </div>
            <div className="cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
              <Avatar />
            </div>
          </div>
        </div>

        {/* Profile Dropdown */}
        {isOpen && (
          <div className="static flex justify-end">
            <div
              ref={profileRef}
              className="bg-primarywhite rounded-2xl shadow-xl absolute pb-2 top-20 right-6 w-[20%]"
            >
              <div className="px-5 pb-4">
                <div className="py-4 flex">
                  <div className="ml-2">
                    <p className="font-poppins font-normal text-base text-black">
                      {getProfileData?.full_name}
                    </p>
                    <p className="font-poppins font-normal text-sm text-textSecondary">
                      {getProfileData?.email}
                    </p>
                  </div>
                </div>
                <div className="flex items-center ml-2">
                  <p className="font-poppins font-normal text-sm text-black">
                    {getProfileData?.user_id}
                  </p>
                </div>
              </div>
              <p className="border border-lightgrey" />
              <div className="mt-2">
                <button
                  className="hover:bg-lightgrey text-black p-1 w-full justify-start"
                  onClick={() => {
                    navigate("/profile");
                    setIsOpen(false);
                  }}
                >
                  <div className="px-4 flex items-center">
                    <MyProfile />
                    <p className="ml-4 font-poppins font-normal text-base">
                      My Profile
                    </p>
                  </div>
                </button>
              </div>
              <div className="ml-1">
                <button
                  className="hover:bg-lightgrey text-black p-1 w-full justify-start"
                  onClick={() => setIsModalVisible(true)}
                >
                  <div className="px-4 flex items-center">
                    <LogOut />
                    <p className="ml-4 font-poppins font-normal text-base">
                      Logout
                    </p>
                  </div>
                </button>
              </div>
            </div>
          </div>
        )}
      </header>
      {/* Logout Confirmation Modal */}
      {isModalVisible && (
        <ConfirmationModel
          onConfirm={logOutClear}
          confirmText="Logout"
          onClose={() => setIsModalVisible(false)}
        />
      )}

      {/* Notification modal */}
      {open && <NotificationModal onClose={() => setOpen(false)} />}
    </>
  );
};

export default Header;
